import type { CreatePresignedUrlDto } from "@/dtos/CreatePresignedUrlDto";
import api from "@/services/api";
import { useMutation } from "@tanstack/react-query";

export const useGeneratePresignedUrl = () => {
  return useMutation({
    mutationKey: ["generatePresignedUrl"],
    mutationFn: async (createPresignedUrlDto: CreatePresignedUrlDto) => {
      const response = await api.post(
        "/storage/presigned-url",
        createPresignedUrlDto
      );

      return response.data;
    },
  });
};
